module.exports = __webpack_public_path__ + "img/poster444.5b76a0e8.png";